package com.routexk.quiz.analytics

import kotlinx.browser.document
import org.w3c.dom.HTMLScriptElement

/**
 * Microsoft Clarity session recordings / heatmaps. Kotlin port of the
 * official snippet: seeds the window.clarity command queue, then loads the
 * tag asynchronously.
 */
object Clarity {

    private const val PROJECT_ID = "xtit3tk65i"

    private var initialized = false

    fun init() {
        if (initialized || PROJECT_ID.isBlank()) return
        initialized = true
        js(
            "window.clarity = window.clarity || function() {" +
                " (window.clarity.q = window.clarity.q || []).push(arguments) }"
        )
        val script = document.createElement("script") as HTMLScriptElement
        script.async = true
        script.src = "https://www.clarity.ms/tag/$PROJECT_ID"
        document.head?.appendChild(script)
    }
}
